export default "__VITE_ASSET__BbVrYVK6__"